import { axiosInstance } from 'src/boot/axios';
import Notify from 'src/constants/notify';
import i18n from 'src/i18n/index.js';

export function isValid({ commit }, payload) {
  const router = this.$router;
  const p = new Promise(function (resolve, reject) {
    return axiosInstance
      .post('CreateAccount/IsValid', {
        username: payload.username,
        birthDate: payload.birthDate,
        agreementId: payload.agreementId,
      })
      .then((response) => {
        commit('setCustomerNumber', response.data);
        resolve();
      })
      .catch((error) => {
        let message;
        if (error.response.data.startsWith('Incorrect combination'))
          message = i18n.global.t('register.notification.unknown-data');
        else if (error.response.data.startsWith('Account not found'))
          message = i18n.global.t('register.notification.unknown-username');
        else if (error.response.data.startsWith('Account already exists')) {
          message = i18n.global.t('register.notification.account-registered');
          router.push({ name: 'login' });
        }

        if (message) {
          Notify.create(
            {
              type: 'negative',
              message: message,
            },
            error.response,
          );
        }

        reject(error);
      });
  });

  return p;
}

export function sendActivationCode({ state }, email) {
  return axiosInstance.post('CreateAccount/SendActivationCode', {
    email: email,
    customerNumber: state.customerNumber,
  });
}

export function validateActivationCode(_, payload) {
  const p = new Promise(function (resolve, reject) {
    return axiosInstance
      .post('CreateAccount/ValidateActivationCode', {
        email: payload.email,
        code: payload.code,
      })
      .then(() => {
        resolve();
      })
      .catch((error) => {
        Notify.create(
          {
            type: 'negative',
            message: i18n.global.t('register.notification.wrong-activation-code'),
          },
          error.response,
        );
        reject();
      });
  });

  return p;
}

export function sendVerificationCode({ commit }, payload) {
  return axiosInstance.post('CreateAccount/SendVerificationCode', payload).then((response) => {
    commit('setReceivedPhoneNumber', response.data.phoneNumber);
    commit('setSendDate', response.data.sendDate);
  });
}

export function createAccount({ commit }, payload) {
  return axiosInstance
    .post('CreateAccount', payload)
    .then(() => {
      commit('setHasSuccessfullyCreatedAccount', true);
      this.$router.push({ name: 'login' });
    })
    .catch((error) => {
      if (error.response.data === 'Verificationcode was invalid') {
        Notify.create(
          {
            type: 'negative',
            message: i18n.global.t('verify.wrong-code'),
          },
          error.response,
        );
      }
    });
}

export function setHasSuccessfullyCreatedAccount({ commit }, payload) {
  commit('setHasSuccessfullyCreatedAccount', payload);
}
